module.exports = __webpack_public_path__ + "static/banner-3875d9d373e9ecd720dc1acf2b08d5f5.jpeg";